import React, { useContext, useEffect } from 'react';

import { hot } from 'react-hot-loader/root';

import { TrackEventContext } from 'common/containers/EventContainer';
import PricingV4, { PricingV4Helmet } from 'common/www/PricingV4';
import styles from 'css-module/components/www/_LandingPricingPageV4.module.scss';

function LandingPricingPageV4() {
  const trackEvent = useContext(TrackEventContext);

  useEffect(() => {
    trackEvent('Viewed Pricing Page');
    trackEvent('Looked at pricing');
  }, [trackEvent]);

  return (
    <div className={styles.landingPricingPageV4}>
      <PricingV4Helmet />
      <PricingV4 />
    </div>
  );
}

export default hot(LandingPricingPageV4);
